import React, { createContext, useContext, useState, useEffect } from "react";

// Upload Context 創建
const NewChatContext = createContext();

export const NewChatProvider = ({ children }) => {
  const [newChatInput, setNewChatInput] = useState(null);
  const [newChatId, setNewChatId] = useState(null);

  useEffect(() => { console.log("newChatInput:", newChatInput) }, [newChatInput])
  // useEffect(() => { console.log("newChatId:", newChatId) }, [newChatId])

  return (
    <NewChatContext.Provider value={{
        newChatInput, setNewChatInput,
        newChatId, setNewChatId,
    }}>
      {children}
    </NewChatContext.Provider>
  );
};

// 自定義 Hook
export const useNewChatContext = () => useContext(NewChatContext);
